import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Select from "react-select";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";


export default class DispatcherSelfTime extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request='GET_SELF';

		try {
			if (localStorage.getItem('dateDispatch')) {
				this.state.filterDate = moment((localStorage.getItem('dateDispatch'))).format();
			} else {
				this.state.filterDate = moment(Date.now()).format();
			}
		} catch (e) {
			console.log(e, 'error')
		}
		this.state.dispatchView = localStorage.getItem('dispatchView') ?? 'day';
		this.state.showStartDate = false;
		this.state.showEndDate = false;
		this.state.showDateRange = false;
		moment.tz.setDefault("America/Phoenix");
		this.state.end_date = moment(Date.now()).format('YYYY-MM-DD');
		this.state.start_date = moment(Date.now()).format('YYYY-MM-DD');
		this.state.dateRangeFormatted = null;
		if (localStorage.getItem('usersDispatchTracking')) {
			this.state.selectedUsers = JSON.parse(localStorage.getItem('usersDispatchTracking')) ?? [];
		} else {
			this.state.selectedUsers = [];
		}
		this.state.users = [];
	}

	async componentDidMount() {
		await this.getDispatch();
	}

	getDispatch = async () => {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ);
		this.read = 'GET_SELF';
		model.filter = {
			'day': this.state.filterDate,
		}
		this.state.filter = model.filter;
		const today = moment(Date.now()).format('YYYY-MM-DD');
		if (this.state.start_date !== today || this.state.end_date !== today) {
			model.filter.start_date = this.state.start_date;
			model.filter.end_date = this.state.end_date;
			this.state.dateRangeFormatted = moment(this.state.start_date).format('dddd MMM D') + ' - ' + moment(this.state.end_date).format('dddd MMM D')
		} else {
			this.state.dateRangeFormatted = null;
		}
		model.search = this.state.search
		this.data = await model.submit(null, this.read);
		let total = this.data.total;
		this.data = this.data.items;
		this.setState({data: this.data, total: total ?? null});
		this.updatePresetsToLocalStorage();
		localStorage.setItem("dateDispatch", this.state.filterDate);
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		await this.setState({filterDate: moment(date).format()});
		this.handleToggleModal('showDate');
		await this.getDispatch();
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		columns = [
			{
				Header: "Date",
				id: "date",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.Date ? moment.parseZone(obj.Date).format('MM/DD/YYYY') : '',
			},
			{
				Header: "Start Time",
				id: "start_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.StartTime !== null ? moment(obj.StartTime).local().format('MM/DD/YYYY h:mm A') : "Not working",
			},
			{
				Header: "End Time",
				id: "end_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.EndTime === null && obj.StartTime ? 'Still working' : obj.EndTime !== null ? moment(obj.EndTime).local().format('MM/DD/YYYY h:mm A') : "Not working",
			},
			{
				Header: "Total Time",
				id: "total_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => Math.floor(moment.duration(obj.TotalTime,'seconds').asHours()) + 'h ' + moment.duration(obj.TotalTime,'seconds').minutes() + 'm ' + moment.duration(obj.TotalTime,'seconds').seconds() + 's',
			},
			{
				Header: "Break Time",
				id: "break_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => Math.floor(moment.duration(obj.BreakTime,'seconds').asHours()) + 'h ' + moment.duration(obj.BreakTime,'seconds').minutes() + 'm ' + moment.duration(obj.BreakTime,'seconds').seconds() + 's',
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<Modal
							isOpen={this.state.showDate}
							toggle={() => this.handleToggleModal('showDate')}
							size={"sm"}
							backdrop={true}
							style={{display: "none"}}
						>
							<ModalBody>
								<Framework.Elements.Date
									label={"Custom Date"}
									value={this.state.filterDate}
									update={this.handleDateChange}
									open={this.state.showDate}
									clearable={false}
									cancelLabel={''}
								/>
							</ModalBody>
						</Modal>
						<div className={"row rbc-toolbar"}>
							<div>
								<IconButton onClick={async () => {
									const today = moment(Date.now()).format('YYYY-MM-DD');
									this.setState({filterDate: moment(this.state.filterDate).subtract(1, 'day').format(), dateRangeFormatted: null, start_date: today, end_date: today}, async () => {
										await this.getDispatch();
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									const today = moment(Date.now()).format('YYYY-MM-DD');
									this.setState({filterDate: moment(Date.now()).format(), dateRangeFormatted: null, start_date: today, end_date: today}, async () => {
										await this.getDispatch();
									})
								}}>Today
								</button>
								<IconButton onClick={async () => {
									const today = moment(Date.now()).format('YYYY-MM-DD');
									this.setState({filterDate: moment(this.state.filterDate).add(1, 'day').format(), dateRangeFormatted: null, start_date: today, end_date: today}, async () => {
										await this.getDispatch();
									})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div className={'col-2'}>
								{this.state.total > 0 && <div style={{marginLeft: 15}}>
									Summed Time: <b>{Math.floor(moment.duration(this.state.total,'seconds').asHours()) + 'h ' + moment.duration(this.state.total,'seconds').minutes() + 'm ' + moment.duration(this.state.total,'seconds').seconds() + 's'} </b>
								</div>}
							</div>
							<div className={"rbc-toolbar-label"}>
								<label onClick={() => {
									this.handleToggleModal('showDate')
								}}>
									{this.state.dateRangeFormatted ? this.state.dateRangeFormatted : moment(this.state.filterDate).format('dddd MMM D')}
								</label>
							</div>
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
